module.exports = __webpack_public_path__ + "img/材料力学5_11.35db0908.jpg";